export default "<div #html_tag_id></div>\n"